import { render } from "./Grid.vue?vue&type=template&id=101bdc2f&scoped=true&ts=true"
import script from "./Grid.vue?vue&type=script&lang=ts"
export * from "./Grid.vue?vue&type=script&lang=ts"

import "./Grid.vue?vue&type=style&index=0&id=101bdc2f&lang=scss&scoped=true"

import exportComponent from "/Users/TomaccioD/Documents/other/nigma-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-101bdc2f"]])

export default __exports__